// Calculate and set featured product height based on regular product items + gap
function setFeaturedProductHeight() {
  console.log('🎯 [FeaturedHeight] Starting setFeaturedProductHeight');
  
  // Find any featured product on the page
  const featuredItem = document.querySelector('.shop__product-item--featured');
  console.log('🎯 [FeaturedHeight] Featured item found:', !!featuredItem, featuredItem);
  if (!featuredItem) {
    console.log('❌ [FeaturedHeight] No featured item found, exiting');
    return;
  }
  
  // Find ANY regular products on the page (not just in featured combo)
  const allRegularProducts = document.querySelectorAll('.shop__product-item.item-product.item-product_white:not(.shop__product-item--featured):not(.shop__product-item--wide)');
  console.log('🎯 [FeaturedHeight] All regular products found on page:', allRegularProducts.length, allRegularProducts);
  
  if (allRegularProducts.length < 1) {
    console.log('❌ [FeaturedHeight] No regular products found on page, exiting');
    return;
  }
  
  // Get the first regular product item
  const regularItem = allRegularProducts[0];
  const regularHeight = regularItem.offsetHeight;
  console.log('🎯 [FeaturedHeight] Regular item height:', regularHeight, 'px', regularItem);
  
  if (regularHeight === 0) {
    console.log('❌ [FeaturedHeight] Regular item has 0 height, exiting');
    return;
  }
  
  // Get gap from parent (usually 9px)
  const regularProductsParent = regularItem.parentElement;
  const computedGap = getComputedStyle(regularProductsParent).gap;
  const gap = parseFloat(computedGap) || 9; // Use 9px as default
  console.log('🎯 [FeaturedHeight] Gap from parent:', gap, 'px (computed:', computedGap, ')');
  console.log('🎯 [FeaturedHeight] Gap parent element:', regularProductsParent);
  
  // Calculate total height: regularHeight * 2 + gap
  // This is the formula: two regular items stacked vertically + gap between them
  const totalHeight = (regularHeight * 2) + gap;
  console.log('🎯 [FeaturedHeight] Total height calculation:', regularHeight, '* 2 +', gap, '=', totalHeight, 'px');
  
  // Set CSS variable on root
  document.documentElement.style.setProperty('--featured-product-height', `${totalHeight}px`);
  console.log('✅ [FeaturedHeight] CSS variable --featured-product-height set to:', totalHeight, 'px');
}

// Set wide image height based on second regular product's image height
function setWideImageHeight() {
  console.log('📐 [WideHeight] Starting setWideImageHeight');
  
  // Find all wide combo containers
  const wideCombos = document.querySelectorAll('.shop__wide-combo, .shop__wide-combo-left');
  console.log('📐 [WideHeight] Wide combos found:', wideCombos.length);
  
  wideCombos.forEach((combo, index) => {
    console.log(`📐 [WideHeight] Processing combo ${index + 1}:`, combo);
    
    // Find ALL regular products (not images) in the combo
    const regularProducts = combo.querySelectorAll('.shop__product-item.item-product.item-product_white:not(.shop__product-item--wide)');
    console.log(`📐 [WideHeight] Regular products in combo ${index + 1}:`, regularProducts.length, regularProducts);
    
    if (regularProducts.length < 2) {
      console.log(`❌ [WideHeight] Less than 2 regular products in combo ${index + 1}, need at least 2`);
      return;
    }
    
    // Get the SECOND regular product (index 1)
    const secondProduct = regularProducts[1];
    console.log(`📐 [WideHeight] Second regular product in combo ${index + 1}:`, secondProduct);
    
    // Find the image container inside the second product
    const secondProductImage = secondProduct.querySelector('.item-product__images:not(.item-product__images--wide):not(.item-product__images--featured)');
    console.log(`📐 [WideHeight] Second product image element in combo ${index + 1}:`, secondProductImage);
    
    if (!secondProductImage) {
      console.log(`❌ [WideHeight] No image found in second product of combo ${index + 1}`);
      return;
    }
    
    // Get the image height
    const imageHeight = secondProductImage.offsetHeight;
    console.log(`📐 [WideHeight] Second product image height in combo ${index + 1}:`, imageHeight, 'px');
    
    if (imageHeight === 0) {
      console.log(`❌ [WideHeight] Second product image has 0 height in combo ${index + 1}`);
      return;
    }
    
    // Set CSS variable for wide images
    document.documentElement.style.setProperty('--wide-product-image-height', `${imageHeight}px`);
    console.log(`✅ [WideHeight] CSS variable --wide-product-image-height set to:`, imageHeight, 'px');
    
    // Log wide images count for debugging
    const wideImages = combo.querySelectorAll('.item-product__images--wide');
    console.log(`📐 [WideHeight] Wide images in combo ${index + 1} will use CSS variable:`, wideImages.length);
  });
}

// Run both functions
function updateHeights() {
  console.log('🚀 [HeightManager] updateHeights called at:', new Date().toISOString());
  console.log('🚀 [HeightManager] Document readyState:', document.readyState);
  setFeaturedProductHeight();
  setWideImageHeight();
  console.log('🚀 [HeightManager] updateHeights completed');
}

// Run on load
if (document.readyState === 'loading') {
  console.log('⏳ [HeightManager] Document still loading, adding DOMContentLoaded listener');
  document.addEventListener('DOMContentLoaded', () => {
    console.log('✅ [HeightManager] DOMContentLoaded fired');
    updateHeights();
  });
} else {
  console.log('✅ [HeightManager] Document already loaded, running immediately');
  updateHeights();
}

// Recalculate on window resize
let resizeTimer;
window.addEventListener('resize', () => {
  console.log('↔️ [HeightManager] Window resized, recalculating in 250ms');
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    console.log('↔️ [HeightManager] Resize complete, updating heights');
    updateHeights();
  }, 250);
});

// Recalculate when images load
window.addEventListener('load', () => {
  console.log('🖼️ [HeightManager] Window load event fired');
  updateHeights();
});

// Export function for external use (e.g., after AJAX product grid updates)
window.updateFeaturedProductHeights = updateHeights;


